import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import LinkButton from '../LinkButton'

const RouterLinkButton = (props) => <LinkButton as={ReactRouterLink} {...props} />

export default RouterLinkButton
